import { PageLoader, texts } from "@sveabank/cc-common";
import { createBrowserRouter } from "react-router";
import ErrorPage from "../error-page";
import ApplicationSettingsPage from "../features/application-settings";
import ChoosePackagePage from "../features/choose-package";
import CreditConfigPage from "../features/choose-package/credit-config/credit-config-page";
import ContactInfoPage from "../features/contact-info-page";
import DashboardPage from "../features/dashboard";
import FullAccessUsersPage from "../features/full-access-users";
import KycPage from "../features/kyc";
import LoginPage from "../features/login/login-page";
import NewCompanyForm from "../features/new-company";
import ClcSummaryPage from "../features/new-company/summary";
import SignPage from "../features/sign-page";
import SummaryPage from "../features/sign-page/summary";
import ApplicationLayout from "../layouts/application-layout";
import BaseLayout from "../layouts/base-layout";
import ClcApplicationLayout from "../layouts/clc-application-layout";
import DashboardLayout from "../layouts/dashboard-layout";
import LoginLayout from "../layouts/login-layout";
import ProtectedLayout from "../layouts/protected-layout";
import Root from "../layouts/root";
import type { SveaRoute } from "../types/route";

const routes: SveaRoute[] = [
	{
		path: "/",
		element: <Root />,
	},
	{
		element: <BaseLayout />,
		children: [
			{
				element: <LoginLayout />,
				children: [
					{
						path: "/login",
						element: <LoginPage />,
					},
				],
			},
			{
				element: <ProtectedLayout />,
				errorElement: <ErrorPage />,
				children: [
					{
						element: <DashboardLayout />,
						children: [
							{
								path: "/dashboard",
								element: <DashboardPage />,
								handle: {
									heading: texts.dashboardPage.heading,
								},
							},
							{
								path: "/new-company-summary/:applicationId",
								element: <ClcSummaryPage />,
								handle: {
									heading: texts.newCompany.pageTitle,
								},
							},
						],
					},
					{
						element: <ApplicationLayout />,
						children: [
							{
								path: "/application/:applicationId",
								element: <PageLoader />,
							},
							{
								path: "/choose-package/:applicationId",
								element: <ChoosePackagePage />,
								handle: {
									heading: texts.choosePackage.heading,
									subheading: texts.choosePackage.subHeading,
									subheading2: texts.choosePackage.subHeading2,
								},
							},
							{
								path: "/adjust-credit/:applicationId",
								element: <CreditConfigPage />,
								handle: {
									heading: texts.adjustCredit.heading,
									subheading: texts.adjustCredit.subHeading,
								},
							},
							{
								path: "/contact/:applicationId",
								element: <ContactInfoPage />,
								handle: {
									heading: texts.contactInfo.heading,
									subheading: texts.contactInfo.subHeading,
									subheading2: texts.contactInfo.subHeading2,
								},
							},
							{
								path: "/full-access-users/:applicationId",
								element: <FullAccessUsersPage />,
								handle: {
									heading: texts.fullAccessUsersPage.heading,
									subheading: texts.fullAccessUsersPage.subHeading,
								},
							},
							{
								path: "/sign/:applicationId",
								element: <SignPage />,
								handle: {
									heading: texts.signPage.heading,
									subheading: texts.signPage.subHeading,
									subheading2: texts.signPage.subHeading2,
								},
							},
							{
								path: "/kyc/:applicationId",
								element: <KycPage />,
								handle: {
									heading: texts.kyc.heading,
									subheading: texts.kyc.subHeading,
								},
							},
							{
								path: "/settings/:applicationId",
								element: <ApplicationSettingsPage />,
								handle: {
									heading: texts.applicationSettings.heading,
									subheading: texts.applicationSettings.subHeading,
								},
							},

							{
								path: "/summary/:applicationId",
								element: <SummaryPage />,
								handle: {
									heading: texts.summaryPage.heading,
									subheading: texts.summaryPage.subHeading,
								},
							},
							{
								// Only for route testing proposes
								path: "/info",
								element: <div>info</div>,
							},
						],
					},
					{
						element: <ClcApplicationLayout />,
						children: [
							{
								path: "/new-company/:applicationId",
								element: <NewCompanyForm />,
								handle: {
									heading: texts.newCompany.pageTitle,
								},
							},
						],
					},
				],
			},
		],
	},
];

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter(routes);
